export default {
      id: "icon-truck-usage",
      viewBox: "0 0 39 24",
      url: __webpack_public_path__ + "icons.svg#icon-truck",
      toString: function () {
        return this.url;
      }
    }